
import { Component, Prop, Vue, Watch } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";

type TransformMenuItem = {
  link: string | Record<string, any>;
  title: string;
  name: string;
  externalLink?: boolean;
};

@Component({
  components: {
    RouterLink,
  },
})
export default class TransformMenu extends Vue {
  @Prop({ required: true }) readonly menuItems!: TransformMenuItem[];
  @Prop({ default: "Menu" }) readonly selectedOption!: string;

  $refs!: { menuList: HTMLUListElement };

  menuOpen = false;

  isDragging = false;
  dragStartX = 0;
  scrollStartX = 0;
  dragThreshold = 5;

  toggleSelectOptionsVisibility() {
    this.menuOpen = !this.menuOpen;
  }

  mounted() {
    this.$nextTick(() => this.scrollActiveItemIntoView());
  }

  @Watch("selectedOption")
  selectedOptionWatcher() {
    this.$nextTick(() => this.scrollActiveItemIntoView());
  }

  scrollActiveItemIntoView() {
    const active = this.$el.querySelector<HTMLElement>(
      ".is--selected-option-true",
    );
    active?.scrollIntoView({ inline: "center", block: "nearest" });
  }

  onPointerDown(e: PointerEvent) {
    const list = this.$refs.menuList;
    if (!list) return;

    this.dragStartX = e.clientX;
    this.scrollStartX = list.scrollLeft;
    this.isDragging = false;

    const onMove = (ev: PointerEvent) => {
      const dx = this.dragStartX - ev.clientX;

      if (Math.abs(dx) > this.dragThreshold) {
        this.isDragging = true;
      }

      list.scrollLeft = this.scrollStartX + dx;
    };

    const onEnd = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onEnd);

      setTimeout(() => {
        this.isDragging = false;
      }, 50);
    };

    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onEnd);
  }

  onItemClick(e: Event) {
    if (this.isDragging) {
      e.preventDefault();
      return;
    }
    this.closeMenu();
  }

  closeMenu() {
    this.menuOpen = false;
  }

  valuesAreSame(string1: string, string2: string): boolean {
    return string1 === string2;
  }
}
